(function () {
  'use strict';
  // Production TikTok gift redemption (regulamin-promocji-prezent). Derived from the Code-validated flow.
  if (location.origin !== 'https://tenbut.pl') return;
  const API = 'https://k-dc4a7e670010c8f6.tenbut.shop/prezent';
  const KEY = 'tb-prezent:claim';
  const COMPLETED = 'tb-prezent:completed-claim';
  const CONTINUE_LOGIN = 'tb-prezent:continue-login';
  const VERIFY_INTENT = 'tb-prezent:verify-claim';
  const TERMS_VERSION = 'regulamin-prezent-2026-11-03';
  customElements.whenDefined('ten-but-prezent').then(async () => {
    const root = document.querySelector('ten-but-prezent[data-redeem]:not([data-capture-only])');
    if (!root || !window.TenButKontoSession) return;
    let client;
    try {
      client = window.TenButKontoSession.createClient({
        fetch: window.fetch.bind(window),
        storage: window.sessionStorage, crypto: window.crypto, origin: location.origin,
        navigate: url => location.assign(url)
      });
    } catch (_) { return; }
    function recordCompletion(result, claimId) {
      if (result.state === 'success' && result.environment === 'production') {
        sessionStorage.setItem(COMPLETED, claimId);
        sessionStorage.removeItem(KEY);
        sessionStorage.removeItem(VERIFY_INTENT);
      }
      return result;
    }
    let recovery;
    function changeAccountAndContinue(claimId) {
      // Only one automatic account change per explicit form submission.
      sessionStorage.removeItem(VERIFY_INTENT);
      sessionStorage.setItem(KEY, claimId);
      sessionStorage.setItem(CONTINUE_LOGIN, '1');
      client.logout();
    }
    async function recover(error, claimId) {
      const final = { 'already-redeemed': 'already_redeemed', 'limit-reached': 'limit_reached', 'terms-required': 'terms_required', 'invalid-code': 'invalid_code' }[error.code];
      const state = final || (error.code === 'identity-mismatch' ? 'account_mismatch' : error.code === 'auth' ? 'authentication_required' :
        ['claim-expired', 'claim-unavailable'].includes(error.code) ? 'claim_expired' : error.code === 'identity-unavailable' ? 'identity_unavailable' : 'processing_unknown');
      await root.resumeDevelopment({ state });
      if (recovery) recovery.remove();
      // Final answers (and an expired session) offer no retry button for the same registration.
      if (state === 'claim_expired' || final) { sessionStorage.removeItem(KEY); sessionStorage.removeItem(COMPLETED); sessionStorage.removeItem(VERIFY_INTENT); return; }
      recovery = document.createElement('button');
      recovery.type = 'button'; recovery.className = 'tb-prezent__button tb-prezent__recovery';
      recovery.style.marginTop = '16px';
      recovery.textContent = state === 'account_mismatch' ? 'Zmień konto Shopify' : state === 'authentication_required' ? 'Potwierdź e-mail w Shopify' : 'Sprawdź zapisane zgłoszenie';
      recovery.addEventListener('click', async () => {
        recovery.disabled = true;
        sessionStorage.setItem(KEY, claimId);
        try {
          if (state === 'account_mismatch' && client.session()?.idToken) { changeAccountAndContinue(claimId); return; }
          if (!client.session() || state === 'authentication_required') { await client.beginLogin(); return; }
          root.waitForDevelopmentVerification();
          const result = recordCompletion(await client.completePrezent(claimId), claimId);
          recovery.remove(); await root.resumeDevelopment(result);
        } catch (next) { await recover(next, claimId); }
      });
      root.querySelector('[role="status"]').after(recovery);
      recovery.focus({ preventScroll: true });
      recovery.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
    root.enableRedeem(async values => {
      const response = await fetch(API + '/lead', {
        method: 'POST', credentials: 'omit', cache: 'no-store', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: values.given_name, email: values.email, phone: values.phone,
          code: values.code, termsAccepted: values.terms, termsVersion: TERMS_VERSION, marketing: values.marketing })
      });
      const result = await response.json().catch(() => ({}));
      if (['invalid_code', 'already_redeemed', 'rate_limited', 'terms_required'].includes(result.state)) return { state: result.state };
      if (!response.ok || result.state !== 'verification_required' || !/^[A-Za-z0-9_-]{43}$/.test(result.receipt || '')) return { state: 'error' };
      const claimId = result.receipt;
      // A failed storage write stops before login, so an unresumable claim is not hidden.
      sessionStorage.setItem(KEY, claimId);
      sessionStorage.setItem(VERIFY_INTENT, claimId);
      if (recovery) recovery.remove();
      root.waitForDevelopmentVerification();
      if (client.session()) {
        try { return recordCompletion(await client.completePrezent(claimId), claimId); }
        catch (error) {
          if (error.code === 'identity-mismatch') {
            // The customer explicitly submitted the claim: continue its native login,
            // instead of leaving the saved form blocked by an unrelated cached account.
            if (client.session()?.idToken) { changeAccountAndContinue(claimId); return { state: 'native_login' }; }
            await recover(error, claimId); return { state: 'account_mismatch' };
          }
          if (['claim-expired', 'claim-unavailable'].includes(error.code)) { await recover(error, claimId); return { state: 'claim_expired' }; }
          if (['already-redeemed', 'limit-reached', 'terms-required', 'invalid-code'].includes(error.code)) { await recover(error, claimId); return { state: error.code.replace('-', '_') }; }
          if (error.code !== 'auth') {
            await recover(error, claimId);
            return { state: error.code === 'identity-unavailable' ? 'identity_unavailable' : 'processing_unknown' };
          }
        }
      }
      await client.beginLogin();
      return { state: 'native_login' };
    });
    // A receipt this browser already displayed (only COMPLETED left) is a revisit: no replay.
    // A new QR scan (code prefilled from ?kod=) always starts with the form, not an older receipt.
    if (!sessionStorage.getItem(KEY) && root.querySelector('[name=code]').value) sessionStorage.removeItem(COMPLETED);
    const revisit = !sessionStorage.getItem(KEY) && !!sessionStorage.getItem(COMPLETED);
    const claim = sessionStorage.getItem(KEY) || sessionStorage.getItem(COMPLETED);
    if (/^[A-Za-z0-9_-]{43}$/.test(claim || '')) {
      if (sessionStorage.getItem(CONTINUE_LOGIN) === '1') {
        sessionStorage.removeItem(CONTINUE_LOGIN);
        root.waitForDevelopmentVerification();
        try { await client.beginLogin(); } catch (error) { await recover(error, claim); }
        return;
      }
      if (!client.session()) { await recover({ code: 'auth' }, claim); return; }
      root.waitForDevelopmentVerification();
      try {
        // The server re-verifies identity and returns the same receipt on repeats.
        const result = recordCompletion(await client.completePrezent(claim), claim);
        await root.resumeDevelopment(result, { revisit });
      } catch (error) {
        if (error.code === 'identity-mismatch' && sessionStorage.getItem(VERIFY_INTENT) === claim && client.session()?.idToken) {
          changeAccountAndContinue(claim);
          return;
        }
        await recover(error, claim);
      }
    }
  });
}());
